
















































































import Component from "vue-class-component";
import BasicForm from "@/layout/form/BasicForm.vue";
import Email from "@/components/inputs/Email.vue";
import {AxiosError, AxiosRequestConfig, AxiosResponse} from "axios";
import Password from "@/components/inputs/Password.vue";
import Loading from "@/components/Loading.vue";
import ErrorMessage from "@/components/messages/ErrorMessage.vue";
import {Vue} from "vue-property-decorator";
import ClientOAuth2 from "client-oauth2";

class LoginRequestPayload{
    email:String="";
    password:String="";
}

interface LoginResponse{
    key:string;
    url:string;
}
interface ClassicResponse{
    message:string;
}
@Component({
    components: {Password, Email, BasicForm,Loading,ErrorMessage}
})
export default class LoginForm extends Vue {
    loginRequest:LoginRequestPayload = new LoginRequestPayload();
    onFly:boolean=false;
    error:any;
   oauthOptions = {
    clientId: this.$store.state.ssoClientId,
    clientSecret: this.$store.state.ssoClientSecret,
    accessTokenUri: this.$store.state.ssoAccessTokenUri,
    authorizationUri: this.$store.state.ssoAuthorizationUri,
    redirectUri: this.$store.state.ssoRedirectUri,
    scopes: []//'get-email'
    };
    oauthClient:ClientOAuth2 = new ClientOAuth2(this.oauthOptions);
    login(e:Event){
        e.preventDefault();
        this.onFly = true;
         this.$http.post("login",this.loginRequest).then( (response:AxiosResponse)=> {
             this.$store.commit('setUser',response.data.user);
             this.$store.commit('setToken',response.data.token);
             this.$store.dispatch("goHome");
             this.$store.dispatch("authInit");
             //console.log("end login");
             this.onFly = false;
         }).catch((error:any)=>{
             this.error = error;
             alert(this.$helper.errorHandler(error));
             this.onFly = false;
         })
    }
    mounted(){
      this.checkOauth();
    }
    goSso(){
      let authorizationUrl = this.oauthClient.code.getUri();
      console.log("authorizationUrl",authorizationUrl);
      location.href = authorizationUrl;
    }
    checkOauth(){
      this.onFly = true;
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      console.log(urlParams);
      console.log(queryString);
      console.log("CHECK OAUTH");
      if(urlParams.get("code")){
        this.$http.post("login",{code:urlParams.get("code")}).then( (response:AxiosResponse)=> {
          console.log("login response",response);
          this.$store.commit('setUser',response.data.user);
          this.$store.commit('setToken',response.data.token);
          this.$store.dispatch("goHome");
          this.$store.dispatch("authInit");
          //console.log("end login");
          this.onFly = false;
        }).catch((error:any)=>{
          this.error = error;
          alert(this.$helper.errorHandler(error));
          this.onFly = false;
        })

        /*
            $accessToken = $this->oauthProvider->getAccessToken('authorization_code', [
                                'code' => $_GET['code']
                            ]);
                            $this->setAccessToken($accessToken);
                            $this->setUser();
         */

      }else{
        this.onFly =  false;
      }


    }

}
